
import { Switch, withStyles } from '@material-ui/core';
import { red } from '@material-ui/core/colors';

export default withStyles({
  switchBase: {
    color: red[500],
  },
})(Switch)